import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getInvestorInvestmentSummary = async (id) => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.INVESTORS_INVESTMENT_SUMMARY}?funderId=${Number(id)}`
  );
  return data.data;
};

export default function useInvestorInvestmentSummary(id) {
  return useQuery(
    [id, "getInvestorInvestmentSummary"],
    getInvestorInvestmentSummary,
    {
      refetchOnWindowFocus: false,
    }
  );
}
